export default __webpack_public_path__ + "static/media/Kat Kun Stick Tuna Flavour.875a95c1.png";